import Title from "./Title";
import listcheck from '../img/checkList.svg'
import arrow from '../img/arrow.svg';
import highlight from '../img/highlight.svg';
import TriImage from "./TriImage";
import BookingImage from "../img/booking.png";
import BookingImage1 from "../img/booking1.png";
import BookingImage3 from "../img/booking3.png";
import Checklist from "./Checklist";
import Btn from "./Btn";

export default function BookNow() {
    return <>
        <div className="bookNow py-5" >
            <div className="container" >
                <div className="row" >
                    <div className="col-lg-7 col-xl-6" >
                        <Title mainClass="order2"
                            titleclass="xl text-dark  text-lg-start text-center mb-1"
                            desclass="mt-2 text-lg-start w-100 text-center mb-2"
                            title={<>Honest. Uniformed. Nice. Knowledgeable. Service.</>}
                  des={<>What makes us best in <span>Moving & Packing Business?</span></>}
                        />
                        <Checklist 
                                list={["Nationwide Locations", "Book Online", "Upfront Pricing", "Office & Business Moving"]}
                                class="mt-4 text-dark" 
                                col="col-sm-6" 
                                liststyle="rounded"  /> 

                        <div className="bookBtnSec d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start mt-4 pt-3 pt-lg-0" >
                            <Btn class="mt-0"
                                arrow={true}
                                wave={true}
                                wavedark={true}
                                href="#"
                            >Book Now </Btn>


                            <div className="serviceDiscount" >
                                <p>Service Starting from</p>
                                <h2>$199 <span>$299 </span></h2>
                            </div> 
                        </div>
                    </div>
                     
                    <div className="col-lg-5 col-xl-6 mt-4 mt-lg-0" >
                        <TriImage mainclass="mt-3" img1={BookingImage1}
                            img2={BookingImage}
                            img3={BookingImage3} />
                    </div>
                </div>
            </div>
        </div>
    </>
}
